import  { FC, ReactNode, useCallback, useState } from 'react';
import { Chip, IconButton, Stack } from '@mui/material';
import { Add } from '@mui/icons-material';


type Props = {
    value?: Array<string>;
    onChange?: (value: Array<string>) => void;
    renderInput?: (props: { value: string; onChange: (value: string) => void }) => ReactNode;
};

export const TagInput: FC<Props> = (props) => {
  const { value, onChange, renderInput } = props;
  const [newTag, setNewTag] = useState('');

  const onAddTag = useCallback(() => {
    const trimmedTag = newTag.trim();
    if (trimmedTag) {
      onChange?.([...(value || []), trimmedTag]);
      setNewTag('');
    }
  }, [newTag, onChange, value]);

  const onRemoveTag = useCallback((tagToRemove: string) => {
    onChange?.(value?.filter(tag => tag !== tagToRemove) || []);
  }, [onChange, value]);

  return (
    <Stack>
      <Stack direction="row" gap={1} alignItems="center">
        {renderInput ? renderInput({ value: newTag, onChange: setNewTag }) : null}
        <IconButton onClick={onAddTag} color="primary" disabled={!newTag.trim()}>
          <Add/>
        </IconButton>
      </Stack>
      <Stack gap={2} direction="row" flexWrap="wrap" mt={1}>
        {value?.map((tag, index) => (
          <Chip
            key={index}
            label={tag}
            variant="outlined"
            onDelete={() => onRemoveTag(tag)}
            sx={{
              height: 'auto',
              fontWeight: 500,
              '& .MuiChip-label': {
                whiteSpace: 'wrap',
              },
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
};
